module.exports = __webpack_public_path__ + "img/top-3-2.06dd25a6.jpg";